import React, { useEffect, useState, memo } from 'react';
import { ClockIcon } from 'lucide-react';
const TimerDisplay = memo(function TimerDisplay({
  minutes,
  seconds
}: {
  minutes: number;
  seconds: number;
}) {
  return <div className="text-2xl md:text-3xl font-black tracking-widest text-white" data-id="element-36">
      00:{minutes.toString().padStart(2, '0')}:
      {seconds.toString().padStart(2, '0')}
    </div>;
});
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(850);
  useEffect(() => {
    // Delay first tick 3s so it doesn't compete with LCP on mobile
    const startDelay = setTimeout(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      const timer = setInterval(() => {
        setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      }, 1000);
      return () => clearInterval(timer);
    }, 3000);
    return () => clearTimeout(startDelay);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-black text-white py-1.5 md:py-2 px-3 md:px-4 border-b-4 border-red-600" style={{
    contain: 'layout style'
  }} data-id="element-37">
      <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center justify-center gap-1 md:gap-6 text-xs md:text-base font-bold text-center" data-id="element-38">
        <div className="flex items-center gap-1.5 md:gap-2 text-yellow-400" data-id="element-39">
          <ClockIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-40" />
          <span data-id="element-41">⏰ OFERTA EXPIRA EN</span>
        </div>
        <TimerDisplay minutes={minutes} seconds={seconds} data-id="element-42" />
        <div className="bg-red-600 text-white px-2 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-base" data-id="element-43">
          ⚡ ÚLTIMOS CUPOS DISPONIBLES
        </div>
      </div>
    </div>;
}